import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { c as v } from "./clsx-OuTLNxxd.js";
import { I as o } from "./icon-BnqXyiyH.js";
import "./components/elements/icon/iconsList.js";
import { useCounter as x } from "./components/elements/inputs/counter/counter.hooks.js";
const h = "_container_v3tha_29", f = "_error_v3tha_43", C = "_disabled_v3tha_46", I = "_label_v3tha_66", e = {
  container: h,
  error: f,
  disabled: C,
  "group-container": "_group-container_v3tha_62",
  label: I
}, k = ({
  inputInitialValue: c,
  placeholderForZero: r,
  onChange: d,
  minValue: m = 0,
  maxValue: u = 1e3,
  disabled: n = !1,
  hasError: t
}) => {
  const { value: s, increment: b, decrement: _, incrementIsDisabled: l, decrementIsDisabled: i } = x(
    c,
    m,
    u,
    n,
    d
  );
  return /* @__PURE__ */ p("div", { className: e.container, children: [
    /* @__PURE__ */ a("button", { onClick: _, disabled: i, "aria-label": "counter-decrementer", children: /* @__PURE__ */ a(
      o,
      {
        className: `${i && e.disabled} ${t && e.error}`,
        name: "minus",
        size: "2xl"
      }
    ) }),
    /* @__PURE__ */ a(
      "input",
      {
        className: v(n && e.disabled),
        readOnly: !0,
        type: "text",
        value: s === 0 && r ? r : s,
        "aria-label": "input-value"
      }
    ),
    /* @__PURE__ */ a("button", { onClick: b, disabled: l, "aria-label": "counter-incrementer", children: /* @__PURE__ */ a(
      o,
      {
        className: `${l && e.disabled} ${t && e.error}`,
        name: "plus",
        size: "2xl"
      }
    ) })
  ] });
};
export {
  k as C,
  e as s
};
